/**
 * Project : workspace
 * File    : CreateBusinessScreen.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package presentation.screens.business.onboard.create_business_screen

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.wrapContentHeight
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.text.input.VisualTransformation
import androidx.compose.ui.unit.dp
import com.parmartechnologies.business.feature.business.viewModel.BusinessViewModel
import com.parmartechnologies.commerce.feature.address.viewModel.AddressViewModel
import com.parmartechnologies.communication.core.handler.AuthHandler
import com.parmartechnologies.core.feature.address.model.Address
import common.asset.ImageAsset
import component.address.AddressLocationInput
import component.button.DefaultButton
import component.input.MobileTextField
import component.input.TextInputField
import component.loader.AppLoader
import component.navigation.TopNavBar
import locale.localization
import navigation.AppNavigator
import presentation.screens.business.onboard.component.BusinessTypeHCard
import theme.ThemeColor
import kotlin.time.ExperimentalTime

/**
 * Represents the create business screen class.
 */

class CreateBusinessScreen{
    @OptIn(ExperimentalTime::class)
    @Composable
    /**
 * Executes the content operation.
 *
 * @receiver TODO
 * @return Unit – no return value.
 */
    fun Content() {
        val viewModel = BusinessViewModel()
        val currentStep = remember { mutableStateOf(0) }
        val newBusiness = viewModel.createBusiness.collectAsState()
        val navigationParam = AppNavigator.shared().getNavigationParam()
        /**
 * Executes the on click save operation.
 *
 * @receiver TODO
 * @return Unit – no return value.
 */
        fun onClickSave() {
            viewModel.createNewBusiness(navigationParam.businessType,arrayListOf()) {
                AppNavigator.shared().goBack()
                AppNavigator.shared().goBack()
            }
        }
        LaunchedEffect(key1 = Unit) {
            viewModel.setMobileForNewBusiness(AuthHandler.shared().mobileNumber)
            viewModel.setEmailForNewBusiness(AuthHandler.shared().email)
            newBusiness.value.Address = Address()
            newBusiness.value.Address.let { AddressViewModel().setNewAddress(it) }
        }
        val mobileErrorState = remember {
            mutableStateOf(false)
        }
        Column(
            modifier = Modifier.fillMaxSize().background(ThemeColor.shared().defaultBakground)
                .padding(bottom = 8.dp)
        ) {
            TopNavBar(title = "Create Store", onBackPress = {
                if (currentStep.value == 0) {
                    AppNavigator.shared().goBack()
                } else {
                    currentStep.value -= 1
                }
            })
            AppLoader(viewModel)
            LazyColumn(modifier = Modifier.weight(1f)) {
                item {
                    BusinessTypeHCard(navigationParam!!.businessType) {
                        if(it != null){
                            navigationParam?.businessType = it
                            AppNavigator.shared().goBack()
                        }
                    }
                }
                item {
                    Column(
                        modifier = Modifier.fillMaxWidth().wrapContentHeight().padding(8.dp)
                    ) {
                        if (newBusiness.value.Name != "") {
                            TextInputField(
                                "",
                                "Name Of the Business/Store",
                                value = viewModel.createBusiness.value.Name
                            ) {
                                viewModel.setNameForNewBusiness(it)
                            }
                        } else {
                            TextInputField("", localization().businessList.nameOfTheBusiness) {
                                viewModel.setNameForNewBusiness(it)
                            }
                        }
                        TextInputField(
                            "",
                            "Email ID",
                            value = newBusiness.value.EmailID
                        ) {
                            viewModel.setEmailForNewBusiness(it)
                        }

                        Spacer(modifier = Modifier.height(8.dp))
                        MobileTextField(
                            mobileNumber = newBusiness.value.MobileNumber,
                            placeholder = "9000000000",
                            trailingIcon = ImageAsset.phone,
                            label = localization().businessList.mobileNumber,
                            errorState = mobileErrorState,
                            visualTransformation = VisualTransformation.None,
                            onChanged = { mob ->
                                viewModel.setMobileForNewBusiness(mob.text.trim())
                            },
                            onDialCodeChange = {
                                viewModel.setDialCodeForNewBusiness(it)
                            }
                        )
                        Spacer(modifier = Modifier.height(8.dp))

                    }
                }
                item {
                    Column(
                        modifier = Modifier.fillMaxWidth().wrapContentHeight().padding(8.dp)
                            .padding(bottom = 100.dp)
                    ) {
                        AddressLocationInput {
                            viewModel.setLocationForNewBusinessAddress(it)
                        }
                        TextInputField(
                            "",
                            localization().businessList.enterPinCode,
                            type = KeyboardType.Number
                        ) {
                            try {
                                viewModel.createBusiness.value.Address.ZipCode = it.toLong()
                            } catch (_: Throwable) {

                            }
                        }
                        TextInputField("", localization().businessList.enterCity) {
                            viewModel.createBusiness.value.Address.City = it
                        }

                        TextInputField("", localization().businessList.state) {
                            viewModel.createBusiness.value.Address.State = it
                        }
                        TextInputField("", localization().businessList.localityAreaStreet) {
                            viewModel.createBusiness.value.Address.Area = it
                        }
                        TextInputField("", localization().businessList.flatnoBuildingName) {
                            viewModel.createBusiness.value.Address.House = it
                        }
                        TextInputField("", localization().businessList.landmark) {
                            viewModel.createBusiness.value.Address.LandMark = it
                        }
//                        TextInputField("", localization().businessList.noteOne) {
//                            viewModel.createBusiness.value.noteOne = it
//                        }
//                        TextInputField("", localization().businessList.noteTwo) {
//                            viewModel.createBusiness.value.noteTwo = it
//                        }
                    }
                }
            }
            DefaultButton(
                localization().button.saveButton,
                onClick = {
                    onClickSave()
                },
                modifier = null
            )
        }
    }
}